import React from 'react';
import { useBootstrapTooltips } from '../../utils/useBootstrapTooltips';

interface LabelWithTooltipProps {
  labelText: string;
  tooltipText?: string;
  className?: string;
}

const LabelWithTooltip: React.FC<LabelWithTooltipProps> = ({ labelText, tooltipText, className }) => {
  useBootstrapTooltips();

  return (
    <label className={className}>
      {labelText && labelText.toTranslatedDisplay()}
      {tooltipText &&
        <i
          className="bi bi-question-circle ms-2"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title={tooltipText.toTranslatedDisplay()}
          style={{ cursor: 'pointer' }}
        ></i>
      }

    </label>
  );
};

export default LabelWithTooltip;
